import Splide from '@splidejs/splide'
import { Popup } from "./popup";
// import { windowWidth } from "./utils";

const sliders = {
  width: window.innerWidth as number,
  init() {
    this.setProdThumbnailsSlider();
    this.setProdThumbnailsPopup();
    this.resetSlider();
    this.topSlider();
    this.brandSlider();
    this.prodSliders();
    this.newItemsSlider();
    this.bottomSlider();
    this.subcats();
    this.setHeroSliders();

    const stock = new Popup("#jsLocationWrap", "#jsOpenLocation", "#jsCloseLocation");
    stock.init();

    const shipping = new Popup("#jsShippingWrap", "#jsOpenShipping", "#jsCloseShipping");
    shipping.init();

    const enquire= new Popup("#jsEnquireWrap", "#jsOpenEnquire", "#jsCloseEnquire");
    enquire.init();

    const gallery = new Popup("#jsGalleryWrap", "#jsOpenGallery", "#jsCloseGallery");
    gallery.init();

    const price = new Popup ("#jsPriceWrap", "#jsOpenPricing", "#jsClosePrice");
    price.init();

    const freeShipping =  new Popup ("#jsFreeShippingWrap", "#jsOpenfreeShipping", "#jsCloseFreeShipping");
    freeShipping.init();

    const bulky =  new Popup ("#jsBulkyWrap", "#jsBulkyOpen", "#jsCloseBulky");
    bulky.init();

  },

    resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider()
      this.setProdThumbnailsPopup()


    const stock = new Popup("#jsLocationWrap", "#jsOpenLocation", "#jsCloseLocation");
    stock.init();

    const shipping = new Popup("#jsShippingWrap", "#jsOpenShipping", "#jsCloseShipping");
    shipping.init();

    const gallery = new Popup("#jsGalleryWrap", "#jsOpenGallery", "#jsCloseGallery");
    gallery.init();

    const price = new Popup ("#jsPriceWrap", "#jsOpenPricing", "#jsClosePrice");
    price.init();

    const bulky =  new Popup ("#jsBulkyWrap", "#jsBulkyOpen", "#jsCloseBulky");
    bulky.init();
    })
  }, 


    noSlider() {
    const noSlider = document.querySelectorAll(
      ".jsNoSlider"
    ) as NodeListOf<HTMLElement>;

    noSlider.forEach((item) => {
      this.removeSlider(item);
    });
  },


    removeSlider(item: HTMLElement) {
    const items = item.querySelectorAll(
      ".splide__slide"
    ) as NodeListOf<HTMLElement>;
    item.classList.remove("splide");
    item.classList.remove("jsCatSlider");
    item.classList.remove("jsProdSlider");
    item.firstElementChild?.classList.remove("splide__track");
    const list = item.firstElementChild?.firstElementChild;
    list?.classList.remove("splide__list");
    list?.classList.add("splide__grid");

    if (items) {
      Array.from(items).forEach((el) => {
        const item = el as HTMLElement;
        item.classList.remove("splide__slide");
      });
    }
  },



      setProdThumbnailsPopup() {
    const porductMainImages = document.getElementById("mainImagePopup") as HTMLElement | undefined
    const thumbnails = document.getElementById("thumbnailsPopup") as HTMLElement | undefined

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'carousel',
        pagination: false,
        arrows: true,
        
        breakpoints: {
          1200: {
            pagination: true,
            arrows: false,
          },
          480: {
            arrows: false,
            pagination: true,
          }
        }
      })

      const thumbnailsNav = new Splide(thumbnails, {
        
        isNavigation: true,
        type: 'carousel',
        pagination: false,
        heightRatio: 4,
        perPage: 4,
        arrow: true,
        gap: "20px",
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 3,
            heightRatio: 1,
            fixedHeight: "70px",
          },
        },
      })

      main.sync(thumbnailsNav)
      main.mount()
      thumbnailsNav.mount()
    }
  },


    topSlider() {
    const slider = document.querySelectorAll('.topSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        perPage: 1,
        type: 'loop',
        direction: 'ttb',
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '20px',
        heightRatio: 1,
        fixedHeight: '45px',
        autoplay: true,
     
        breakpoints: {
          1200: {
             fixedHeight: '35px',
          },
        },
      }).mount()
    })
  },

    brandSlider() {
    const slider = document.getElementById('brands') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 8,
        type: 'carousel',
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '20px',
        breakpoints: {
          768: {
            perPage: 4,
            pagination: false,
            gap: '15px'
          },
          1200: {
            perPage: 6,

          },
        },
      }).mount()
    }
  },

    prodSliders() {
    const slider = document.querySelectorAll('.jsProdSliders') as NodeListOf<
      HTMLElement
    >

    slider.forEach((slide) => {
      new Splide(slide, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        gap: '10px',
        perMove: 1, 
        perPage: 5,
        speed: 1200,
        breakpoints: {
          1400: {
            perPage: 3,
         
          },

          990: {
            perPage: 3,
         
          },

          768: {
            perPage: 2,
            arrow: false,
           
          },

          500: {
            perPage: 1,
            arrows: false,
            gap: '10px',
            perMove: 1,
            padding: { right: "30%" },
          
          },
        },
      }).mount()
    })
  },

      newItemsSlider() {
    const slider = document.getElementById('jsNewItems') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 4,
        type: 'carousel',
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '29px',
        breakpoints: {

          1200: {
            perPage: 2,
            padding: { right: "30%" },
            gap: '25px',

          },

              768: {
        perPage: 1,
        pagination: false,
        gap: '0px',
        padding: { right: "30%" },
        },

          500: {
        perPage: 1,
        pagination: false,
        gap: '0px',
        padding: { right: "0%" },
        },
        },
      }).mount()
    }
  },

    bottomSlider() {
    const slider = document.getElementById('jsBtmAds') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 3,
        type: 'carousel',
        pagination: false,
        arrows: false,
        speed: 800,
        gap: '23px',
        destroy: true,
        breakpoints: {

          1200: {
            perPage: 2,
            padding: { right: "30%" },
            gap: '25px',
            destroy: false,
          },

              768: {
        perPage: 1,
        pagination: false,
        gap: '0px',
        padding: { right: "30%" },
        },

          500: {
        perPage: 1,
        pagination: false,
        gap: '0px',
        padding: { right: "0%" },
        },
        },
      }).mount()
    }
  },


      subcats() {
    const slider = document.getElementById('subcats') as HTMLElement | undefined

    if (slider) {
      new Splide(slider, {
        perPage: 6,
        type: 'carousel',
        pagination: true,
        arrows: false,
        speed: 800,
        gap: '10px',
        breakpoints: {
            500: {
            perPage: 2,
            
            gap: '8px'
          },
          768: {
            perPage: 3,
            
            gap: '8px'
          },
          1200: {
            perPage: 4,

          },
        },
      }).mount()
    }
  },


 setProdThumbnailsSlider() {
    const slider = document.getElementById("mainImage") as
      | HTMLElement
      | undefined;
    if (slider) {
      if (this.width < 769) {
        const main = new Splide(slider, {
          type: "loop",
          pagination: true,
          arrows: false,
          gap: "20px",
          perPage: 1,
          perMove: 1,
        });
        main.mount();
      } else {
        this.removeSlider(slider);
      }
    }
  },


       setHeroSliders() {
    const heroSliders = document.querySelectorAll(".jsHeroSlide") as NodeListOf<HTMLElement>
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        perPage: 1,
        type: 'fade',
        speed: 2000,
        arrows: true,
        pagination: true,
        autoplay: true,
      })
      slider.mount()
    })
  },

}

export default sliders